import { render, staticRenderFns } from "./DispatchOrdersTable.vue?vue&type=template&id=36812776&scoped=true"
import script from "./DispatchOrdersTable.vue?vue&type=script&lang=ts"
export * from "./DispatchOrdersTable.vue?vue&type=script&lang=ts"
import style0 from "./DispatchOrdersTable.vue?vue&type=style&index=0&id=36812776&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36812776",
  null
  
)

export default component.exports